export default {
  init() {
    /*
    |--------------------------------------------------------------------------
    | ELEMENTOS
    |--------------------------------------------------------------------------
    */
    const filtros = document.querySelectorAll(
      '.publicacoes-filtros button'
    );

    const busca = document.getElementById(
      'buscar-publicacao'
    );

    const grid = document.getElementById(
      'publicacoes-grid'
    );

    /*
    |--------------------------------------------------------------------------
    | CACHE DOS CARDS
    |--------------------------------------------------------------------------
    */

    const cards = document.querySelectorAll(
      '.card-publicacao'
    );

    /*
    |--------------------------------------------------------------------------
    | FILTRO DE CATEGORIA
    |--------------------------------------------------------------------------
    */

    filtros.forEach(botao => {
      botao.addEventListener('click', () => {
        filtros.forEach(btn => {
          btn.classList.remove('active');
        });
        botao.classList.add('active');
        aplicarFiltros();
      });
    });

    /*
    |--------------------------------------------------------------------------
    | BUSCA COM DEBOUNCE
    |--------------------------------------------------------------------------
    */

    if (busca) {
      let debounceTimer;
      busca.addEventListener('keyup', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(aplicarFiltros, 200);
      });
    }

    /*
    |--------------------------------------------------------------------------
    | APLICAR FILTROS
    |--------------------------------------------------------------------------
    */
    function normalizarTexto(texto) {
      return texto
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function aplicarFiltros() {

      const categoriaButton = document.querySelector(
        '.publicacoes-filtros button.active'
      );

      const categoriaAtiva = categoriaButton
        ? categoriaButton.dataset.category
        : '';

      const termoBusca = busca
        ? normalizarTexto( busca.value.trim() )
        : '';

      let resultados = 0;

      cards.forEach(card => {

        const categoria = card.dataset.category || '';

        const tituloElement = card.querySelector(
          '.card-title'
        );

        const titulo = tituloElement
        ? normalizarTexto( tituloElement.innerText ) : '';

        const resumoElement = card.querySelector(
          '.card-resumo'
        );

        const resumo = resumoElement
          ? normalizarTexto( resumoElement.innerText )
          : '';

        /*
        |--------------------------------------------------------------------------
        | MATCH CATEGORIA
        |--------------------------------------------------------------------------
        */

        const matchCategoria =
          categoriaAtiva === '' ||
          categoria === categoriaAtiva;

        /*
        |--------------------------------------------------------------------------
        | MATCH BUSCA
        |--------------------------------------------------------------------------
        */

        const matchBusca =
          titulo.includes(termoBusca) ||
          resumo.includes(termoBusca);

        /*
        |--------------------------------------------------------------------------
        | EXIBIÇÃO
        |--------------------------------------------------------------------------
        */

        if (matchCategoria && matchBusca) {
          card.style.display = '';
          resultados++;
        } else {
          card.style.display = 'none';
        }
      });

      atualizarEstadoVazio(resultados);
    }

    /*
    |--------------------------------------------------------------------------
    | ESTADO VAZIO
    |--------------------------------------------------------------------------
    */

    function atualizarEstadoVazio(total) {

      let emptyState = document.querySelector(
        '.publicacoes-empty-js'
      );

      if (total === 0) {

        /*
        |--------------------------------------------------------------------------
        | MOSTRAR EMPTY
        |--------------------------------------------------------------------------
        */

        if (!emptyState) {

          emptyState = document.createElement('div');

          emptyState.classList.add(
            'publicacoes-empty',
            'publicacoes-empty-js'
          );

          emptyState.innerHTML = `
            <h3>
              Nenhuma publicação encontrada.
            </h3>
          `;

          grid.appendChild(emptyState);

        }

      } else {

        /*
        |--------------------------------------------------------------------------
        | REMOVER EMPTY
        |--------------------------------------------------------------------------
        */

        if (emptyState) {

          emptyState.remove();

        }

      }

    }

    /*
    |--------------------------------------------------------------------------
    | SCROLL HORIZONTAL MOBILE
    |--------------------------------------------------------------------------
    */

    const filtrosContainer = document.querySelector(
      '.publicacoes-filtros'
    );

    if (filtrosContainer) {

      /*
      |--------------------------------------------------------------------------
      | DRAG DESKTOP
      |--------------------------------------------------------------------------
      */

      let isDown = false;
      let startX;
      let scrollLeft;

      filtrosContainer.addEventListener(
        'mousedown',
        (e) => {
          isDown = true;
          filtrosContainer.classList.add('dragging');

          startX =
            e.pageX -
            filtrosContainer.offsetLeft;

          scrollLeft =
            filtrosContainer.scrollLeft;
        }
      );

      filtrosContainer.addEventListener(
        'mouseleave',
        () => {
          isDown = false;

          filtrosContainer.classList.remove(
            'dragging'
          );
        }
      );

      filtrosContainer.addEventListener(
        'mouseup',
        () => {
          isDown = false;

          filtrosContainer.classList.remove(
            'dragging'
          );
        }
      );

      filtrosContainer.addEventListener(
        'mousemove',
        (e) => {
          if (!isDown) return;
          e.preventDefault();

          const x =
            e.pageX -
            filtrosContainer.offsetLeft;

          const walk =
            (x - startX) * 1.5;

          filtrosContainer.scrollLeft =
            scrollLeft - walk;
        }
      );

      /*
      |--------------------------------------------------------------------------
      | WHEEL HORIZONTAL
      |--------------------------------------------------------------------------
      */

      filtrosContainer.addEventListener(
        'wheel',
        (e) => {
          if (window.innerWidth < 1024) {
            e.preventDefault();
            filtrosContainer.scrollLeft += e.deltaY;
          }
        },
        { passive: false }
      );

    }

    /*
    |--------------------------------------------------------------------------
    | ESTADO INICIAL
    |--------------------------------------------------------------------------
    */

    aplicarFiltros();

  },

  finalize() {

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/publicacoes.js